import * as React from 'react';
import './Spinner.scss';
export const Spinner = () => {
    return (
        <svg className={'byzzer-mask__loading-spinner'} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <circle pathLength={1} cx="50" cy="50" r="45" />
        </svg>
    );
};
